import csCreditStep1 from '@/assets/images/credits-page/cs-credits-step-1.jpg?w=1200'
import csCreditStep1Avif from '@/assets/images/credits-page/cs-credits-step-1.jpg?w=1200&format=avif&as=srcset'
import csCreditStep1Webp from '@/assets/images/credits-page/cs-credits-step-1.jpg?w=1200&format=webp&as=srcset'
import csCreditStep2 from '@/assets/images/credits-page/cs-credits-step-2.jpg?w=1200'
import csCreditStep2Avif from '@/assets/images/credits-page/cs-credits-step-2.jpg?w=1200&format=avif&as=srcset'
import csCreditStep2Webp from '@/assets/images/credits-page/cs-credits-step-2.jpg?w=1200&format=webp&as=srcset'
import csCreditStep3 from '@/assets/images/credits-page/cs-credits-step-3.jpg?w=778'
import csCreditStep3Avif from '@/assets/images/credits-page/cs-credits-step-3.jpg?w=778&format=avif&as=srcset'
import csCreditStep3Webp from '@/assets/images/credits-page/cs-credits-step-3.jpg?w=778&format=webp&as=srcset'
import csCreditStep4 from '@/assets/images/credits-page/cs-credits-step-4.jpg?w=1200'
import csCreditStep4Avif from '@/assets/images/credits-page/cs-credits-step-4.jpg?w=1200&format=avif&as=srcset'
import csCreditStep4Webp from '@/assets/images/credits-page/cs-credits-step-4.jpg?w=1200&format=webp&as=srcset'
import csMobileCreditStep11 from '@/assets/images/credits-page/cs-mobile-credits-step-1-1.jpg?w=584'
import csMobileCreditStep11Avif from '@/assets/images/credits-page/cs-mobile-credits-step-1-1.jpg?w=584&format=avif&as=srcset'
import csMobileCreditStep11Webp from '@/assets/images/credits-page/cs-mobile-credits-step-1-1.jpg?w=584&format=webp&as=srcset'
import csMobileCreditStep12 from '@/assets/images/credits-page/cs-mobile-credits-step-1-2.jpg?w=584'
import csMobileCreditStep12Avif from '@/assets/images/credits-page/cs-mobile-credits-step-1-2.jpg?w=584&format=avif&as=srcset'
import csMobileCreditStep12Webp from '@/assets/images/credits-page/cs-mobile-credits-step-1-2.jpg?w=584&format=webp&as=srcset'
import csMobileCreditStep21 from '@/assets/images/credits-page/cs-mobile-credits-step-2-1.jpg?w=584'
import csMobileCreditStep21Avif from '@/assets/images/credits-page/cs-mobile-credits-step-2-1.jpg?w=584&format=avif&as=srcset'
import csMobileCreditStep21Webp from '@/assets/images/credits-page/cs-mobile-credits-step-2-1.jpg?w=584&format=webp&as=srcset'
import csMobileCreditStep22 from '@/assets/images/credits-page/cs-mobile-credits-step-2-2.jpg?w=584'
import csMobileCreditStep22Avif from '@/assets/images/credits-page/cs-mobile-credits-step-2-2.jpg?w=584&format=avif&as=srcset'
import csMobileCreditStep22Webp from '@/assets/images/credits-page/cs-mobile-credits-step-2-2.jpg?w=584&format=webp&as=srcset'
import csMobileCreditStep3 from '@/assets/images/credits-page/cs-mobile-credits-step-3.jpg?w=584'
import csMobileCreditStep3Avif from '@/assets/images/credits-page/cs-mobile-credits-step-3.jpg?w=584&format=avif&as=srcset'
import csMobileCreditStep3Webp from '@/assets/images/credits-page/cs-mobile-credits-step-3.jpg?w=584&format=webp&as=srcset'
import csMobileCreditStep4 from '@/assets/images/credits-page/cs-mobile-credits-step-4.jpg?w=584'
import csMobileCreditStep4Avif from '@/assets/images/credits-page/cs-mobile-credits-step-4.jpg?w=584&format=avif&as=srcset'
import csMobileCreditStep4Webp from '@/assets/images/credits-page/cs-mobile-credits-step-4.jpg?w=584&format=webp&as=srcset'
import huCreditStep1 from '@/assets/images/credits-page/hu-credits-step-1.jpg?w=1200'
import huCreditStep1Avif from '@/assets/images/credits-page/hu-credits-step-1.jpg?w=1200&format=avif&as=srcset'
import huCreditStep1Webp from '@/assets/images/credits-page/hu-credits-step-1.jpg?w=1200&format=webp&as=srcset'
import huCreditStep2 from '@/assets/images/credits-page/hu-credits-step-2.jpg?w=1200'
import huCreditStep2Avif from '@/assets/images/credits-page/hu-credits-step-2.jpg?w=1200&format=avif&as=srcset'
import huCreditStep2Webp from '@/assets/images/credits-page/hu-credits-step-2.jpg?w=1200&format=webp&as=srcset'
import huCreditStep3 from '@/assets/images/credits-page/hu-credits-step-3.jpg?w=778'
import huCreditStep3Avif from '@/assets/images/credits-page/hu-credits-step-3.jpg?w=778&format=avif&as=srcset'
import huCreditStep3Webp from '@/assets/images/credits-page/hu-credits-step-3.jpg?w=778&format=webp&as=srcset'
import huCreditStep4 from '@/assets/images/credits-page/hu-credits-step-4.jpg?w=1200'
import huCreditStep4Avif from '@/assets/images/credits-page/hu-credits-step-4.jpg?w=1200&format=avif&as=srcset'
import huCreditStep4Webp from '@/assets/images/credits-page/hu-credits-step-4.jpg?w=1200&format=webp&as=srcset'
import huMobileCreditStep11 from '@/assets/images/credits-page/hu-mobile-credits-step-1-1.jpg?w=584'
import huMobileCreditStep11Avif from '@/assets/images/credits-page/hu-mobile-credits-step-1-1.jpg?w=584&format=avif&as=srcset'
import huMobileCreditStep11Webp from '@/assets/images/credits-page/hu-mobile-credits-step-1-1.jpg?w=584&format=webp&as=srcset'
import huMobileCreditStep12 from '@/assets/images/credits-page/hu-mobile-credits-step-1-2.jpg?w=584'
import huMobileCreditStep12Avif from '@/assets/images/credits-page/hu-mobile-credits-step-1-2.jpg?w=584&format=avif&as=srcset'
import huMobileCreditStep12Webp from '@/assets/images/credits-page/hu-mobile-credits-step-1-2.jpg?w=584&format=webp&as=srcset'
import huMobileCreditStep21 from '@/assets/images/credits-page/hu-mobile-credits-step-2-1.jpg?w=584'
import huMobileCreditStep21Avif from '@/assets/images/credits-page/hu-mobile-credits-step-2-1.jpg?w=584&format=avif&as=srcset'
import huMobileCreditStep21Webp from '@/assets/images/credits-page/hu-mobile-credits-step-2-1.jpg?w=584&format=webp&as=srcset'
import huMobileCreditStep22 from '@/assets/images/credits-page/hu-mobile-credits-step-2-2.jpg?w=584'
import huMobileCreditStep22Avif from '@/assets/images/credits-page/hu-mobile-credits-step-2-2.jpg?w=584&format=avif&as=srcset'
import huMobileCreditStep22Webp from '@/assets/images/credits-page/hu-mobile-credits-step-2-2.jpg?w=584&format=webp&as=srcset'
import huMobileCreditStep3 from '@/assets/images/credits-page/hu-mobile-credits-step-3.jpg?w=584'
import huMobileCreditStep3Avif from '@/assets/images/credits-page/hu-mobile-credits-step-3.jpg?w=584&format=avif&as=srcset'
import huMobileCreditStep3Webp from '@/assets/images/credits-page/hu-mobile-credits-step-3.jpg?w=584&format=webp&as=srcset'
import huMobileCreditStep4 from '@/assets/images/credits-page/hu-mobile-credits-step-4.jpg?w=584'
import huMobileCreditStep4Avif from '@/assets/images/credits-page/hu-mobile-credits-step-4.jpg?w=584&format=avif&as=srcset'
import huMobileCreditStep4Webp from '@/assets/images/credits-page/hu-mobile-credits-step-4.jpg?w=584&format=webp&as=srcset'
import plCreditStep1 from '@/assets/images/credits-page/pl-credits-step-1.jpg?w=1200'
import plCreditStep1Avif from '@/assets/images/credits-page/pl-credits-step-1.jpg?w=1200&format=avif&as=srcset'
import plCreditStep1Webp from '@/assets/images/credits-page/pl-credits-step-1.jpg?w=1200&format=webp&as=srcset'
import plCreditStep2 from '@/assets/images/credits-page/pl-credits-step-2.jpg?w=1200'
import plCreditStep2Avif from '@/assets/images/credits-page/pl-credits-step-2.jpg?w=1200&format=avif&as=srcset'
import plCreditStep2Webp from '@/assets/images/credits-page/pl-credits-step-2.jpg?w=1200&format=webp&as=srcset'
import plCreditStep3 from '@/assets/images/credits-page/pl-credits-step-3.jpg?w=778'
import plCreditStep3Avif from '@/assets/images/credits-page/pl-credits-step-3.jpg?w=778&format=avif&as=srcset'
import plCreditStep3Webp from '@/assets/images/credits-page/pl-credits-step-3.jpg?w=778&format=webp&as=srcset'
import plCreditStep4 from '@/assets/images/credits-page/pl-credits-step-4.jpg?w=1200'
import plCreditStep4Avif from '@/assets/images/credits-page/pl-credits-step-4.jpg?w=1200&format=avif&as=srcset'
import plCreditStep4Webp from '@/assets/images/credits-page/pl-credits-step-4.jpg?w=1200&format=webp&as=srcset'
import plMobileCreditStep11 from '@/assets/images/credits-page/pl-mobile-credits-step-1-1.jpg?w=584'
import plMobileCreditStep11Avif from '@/assets/images/credits-page/pl-mobile-credits-step-1-1.jpg?w=584&format=avif&as=srcset'
import plMobileCreditStep11Webp from '@/assets/images/credits-page/pl-mobile-credits-step-1-1.jpg?w=584&format=webp&as=srcset'
import plMobileCreditStep12 from '@/assets/images/credits-page/pl-mobile-credits-step-1-2.jpg?w=584'
import plMobileCreditStep12Avif from '@/assets/images/credits-page/pl-mobile-credits-step-1-2.jpg?w=584&format=avif&as=srcset'
import plMobileCreditStep12Webp from '@/assets/images/credits-page/pl-mobile-credits-step-1-2.jpg?w=584&format=webp&as=srcset'
import plMobileCreditStep21 from '@/assets/images/credits-page/pl-mobile-credits-step-2-1.jpg?w=584'
import plMobileCreditStep21Avif from '@/assets/images/credits-page/pl-mobile-credits-step-2-1.jpg?w=584&format=avif&as=srcset'
import plMobileCreditStep21Webp from '@/assets/images/credits-page/pl-mobile-credits-step-2-1.jpg?w=584&format=webp&as=srcset'
import plMobileCreditStep22 from '@/assets/images/credits-page/pl-mobile-credits-step-2-2.jpg?w=584'
import plMobileCreditStep22Avif from '@/assets/images/credits-page/pl-mobile-credits-step-2-2.jpg?w=584&format=avif&as=srcset'
import plMobileCreditStep22Webp from '@/assets/images/credits-page/pl-mobile-credits-step-2-2.jpg?w=584&format=webp&as=srcset'
import plMobileCreditStep3 from '@/assets/images/credits-page/pl-mobile-credits-step-3.jpg?w=584'
import plMobileCreditStep3Avif from '@/assets/images/credits-page/pl-mobile-credits-step-3.jpg?w=584&format=avif&as=srcset'
import plMobileCreditStep3Webp from '@/assets/images/credits-page/pl-mobile-credits-step-3.jpg?w=584&format=webp&as=srcset'
import plMobileCreditStep4 from '@/assets/images/credits-page/pl-mobile-credits-step-4.jpg?w=584'
import plMobileCreditStep4Avif from '@/assets/images/credits-page/pl-mobile-credits-step-4.jpg?w=584&format=avif&as=srcset'
import plMobileCreditStep4Webp from '@/assets/images/credits-page/pl-mobile-credits-step-4.jpg?w=584&format=webp&as=srcset'
import roCreditStep1 from '@/assets/images/credits-page/ro-credits-step-1.jpg?w=1200'
import roCreditStep1Avif from '@/assets/images/credits-page/ro-credits-step-1.jpg?w=1200&format=avif&as=srcset'
import roCreditStep1Webp from '@/assets/images/credits-page/ro-credits-step-1.jpg?w=1200&format=webp&as=srcset'
import roCreditStep2 from '@/assets/images/credits-page/ro-credits-step-2.jpg?w=1200'
import roCreditStep2Avif from '@/assets/images/credits-page/ro-credits-step-2.jpg?w=1200&format=avif&as=srcset'
import roCreditStep2Webp from '@/assets/images/credits-page/ro-credits-step-2.jpg?w=1200&format=webp&as=srcset'
import roCreditStep3 from '@/assets/images/credits-page/ro-credits-step-3.jpg?w=778'
import roCreditStep3Avif from '@/assets/images/credits-page/ro-credits-step-3.jpg?w=778&format=avif&as=srcset'
import roCreditStep3Webp from '@/assets/images/credits-page/ro-credits-step-3.jpg?w=778&format=webp&as=srcset'
import roCreditStep4 from '@/assets/images/credits-page/ro-credits-step-4.jpg?w=1200'
import roCreditStep4Avif from '@/assets/images/credits-page/ro-credits-step-4.jpg?w=1200&format=avif&as=srcset'
import roCreditStep4Webp from '@/assets/images/credits-page/ro-credits-step-4.jpg?w=1200&format=webp&as=srcset'
import roMobileCreditStep11 from '@/assets/images/credits-page/ro-mobile-credits-step-1-1.jpg?w=584'
import roMobileCreditStep11Avif from '@/assets/images/credits-page/ro-mobile-credits-step-1-1.jpg?w=584&format=avif&as=srcset'
import roMobileCreditStep11Webp from '@/assets/images/credits-page/ro-mobile-credits-step-1-1.jpg?w=584&format=webp&as=srcset'
import roMobileCreditStep12 from '@/assets/images/credits-page/ro-mobile-credits-step-1-2.jpg?w=584'
import roMobileCreditStep12Avif from '@/assets/images/credits-page/ro-mobile-credits-step-1-2.jpg?w=584&format=avif&as=srcset'
import roMobileCreditStep12Webp from '@/assets/images/credits-page/ro-mobile-credits-step-1-2.jpg?w=584&format=webp&as=srcset'
import roMobileCreditStep21 from '@/assets/images/credits-page/ro-mobile-credits-step-2-1.jpg?w=584'
import roMobileCreditStep21Avif from '@/assets/images/credits-page/ro-mobile-credits-step-2-1.jpg?w=584&format=avif&as=srcset'
import roMobileCreditStep21Webp from '@/assets/images/credits-page/ro-mobile-credits-step-2-1.jpg?w=584&format=webp&as=srcset'
import roMobileCreditStep22 from '@/assets/images/credits-page/ro-mobile-credits-step-2-2.jpg?w=584'
import roMobileCreditStep22Avif from '@/assets/images/credits-page/ro-mobile-credits-step-2-2.jpg?w=584&format=avif&as=srcset'
import roMobileCreditStep22Webp from '@/assets/images/credits-page/ro-mobile-credits-step-2-2.jpg?w=584&format=webp&as=srcset'
import roMobileCreditStep3 from '@/assets/images/credits-page/ro-mobile-credits-step-3.jpg?w=584'
import roMobileCreditStep3Avif from '@/assets/images/credits-page/ro-mobile-credits-step-3.jpg?w=584&format=avif&as=srcset'
import roMobileCreditStep3Webp from '@/assets/images/credits-page/ro-mobile-credits-step-3.jpg?w=584&format=webp&as=srcset'
import roMobileCreditStep4 from '@/assets/images/credits-page/ro-mobile-credits-step-4.jpg?w=584'
import roMobileCreditStep4Avif from '@/assets/images/credits-page/ro-mobile-credits-step-4.jpg?w=584&format=avif&as=srcset'
import roMobileCreditStep4Webp from '@/assets/images/credits-page/ro-mobile-credits-step-4.jpg?w=584&format=webp&as=srcset'
import skCreditStep1 from '@/assets/images/credits-page/sk-credits-step-1.jpg?w=1200'
import skCreditStep1Avif from '@/assets/images/credits-page/sk-credits-step-1.jpg?w=1200&format=avif&as=srcset'
import skCreditStep1Webp from '@/assets/images/credits-page/sk-credits-step-1.jpg?w=1200&format=webp&as=srcset'
import skCreditStep2 from '@/assets/images/credits-page/sk-credits-step-2.jpg?w=1200'
import skCreditStep2Avif from '@/assets/images/credits-page/sk-credits-step-2.jpg?w=1200&format=avif&as=srcset'
import skCreditStep2Webp from '@/assets/images/credits-page/sk-credits-step-2.jpg?w=1200&format=webp&as=srcset'
import skCreditStep3 from '@/assets/images/credits-page/sk-credits-step-3.jpg?w=778'
import skCreditStep3Avif from '@/assets/images/credits-page/sk-credits-step-3.jpg?w=778&format=avif&as=srcset'
import skCreditStep3Webp from '@/assets/images/credits-page/sk-credits-step-3.jpg?w=778&format=webp&as=srcset'
import skCreditStep4 from '@/assets/images/credits-page/sk-credits-step-4.jpg?w=1200'
import skCreditStep4Avif from '@/assets/images/credits-page/sk-credits-step-4.jpg?w=1200&format=avif&as=srcset'
import skCreditStep4Webp from '@/assets/images/credits-page/sk-credits-step-4.jpg?w=1200&format=webp&as=srcset'
import skMobileCreditStep11 from '@/assets/images/credits-page/sk-mobile-credits-step-1-1.jpg?w=584'
import skMobileCreditStep11Avif from '@/assets/images/credits-page/sk-mobile-credits-step-1-1.jpg?w=584&format=avif&as=srcset'
import skMobileCreditStep11Webp from '@/assets/images/credits-page/sk-mobile-credits-step-1-1.jpg?w=584&format=webp&as=srcset'
import skMobileCreditStep12 from '@/assets/images/credits-page/sk-mobile-credits-step-1-2.jpg?w=584'
import skMobileCreditStep12Avif from '@/assets/images/credits-page/sk-mobile-credits-step-1-2.jpg?w=584&format=avif&as=srcset'
import skMobileCreditStep12Webp from '@/assets/images/credits-page/sk-mobile-credits-step-1-2.jpg?w=584&format=webp&as=srcset'
import skMobileCreditStep21 from '@/assets/images/credits-page/sk-mobile-credits-step-2-1.jpg?w=584'
import skMobileCreditStep21Avif from '@/assets/images/credits-page/sk-mobile-credits-step-2-1.jpg?w=584&format=avif&as=srcset'
import skMobileCreditStep21Webp from '@/assets/images/credits-page/sk-mobile-credits-step-2-1.jpg?w=584&format=webp&as=srcset'
import skMobileCreditStep22 from '@/assets/images/credits-page/sk-mobile-credits-step-2-2.jpg?w=584'
import skMobileCreditStep22Avif from '@/assets/images/credits-page/sk-mobile-credits-step-2-2.jpg?w=584&format=avif&as=srcset'
import skMobileCreditStep22Webp from '@/assets/images/credits-page/sk-mobile-credits-step-2-2.jpg?w=584&format=webp&as=srcset'
import skMobileCreditStep3 from '@/assets/images/credits-page/sk-mobile-credits-step-3.jpg?w=584'
import skMobileCreditStep3Avif from '@/assets/images/credits-page/sk-mobile-credits-step-3.jpg?w=584&format=avif&as=srcset'
import skMobileCreditStep3Webp from '@/assets/images/credits-page/sk-mobile-credits-step-3.jpg?w=584&format=webp&as=srcset'
import skMobileCreditStep4 from '@/assets/images/credits-page/sk-mobile-credits-step-4.jpg?w=584'
import skMobileCreditStep4Avif from '@/assets/images/credits-page/sk-mobile-credits-step-4.jpg?w=584&format=avif&as=srcset'
import skMobileCreditStep4Webp from '@/assets/images/credits-page/sk-mobile-credits-step-4.jpg?w=584&format=webp&as=srcset'
import deCreditStep1 from '@/assets/images/credits-page/de-credits-step-1.jpg?w=1200'
import deCreditStep1Avif from '@/assets/images/credits-page/de-credits-step-1.jpg?w=1200&format=avif&as=srcset'
import deCreditStep1Webp from '@/assets/images/credits-page/de-credits-step-1.jpg?w=1200&format=webp&as=srcset'
import deCreditStep2 from '@/assets/images/credits-page/de-credits-step-2.jpg?w=1200'
import deCreditStep2Avif from '@/assets/images/credits-page/de-credits-step-2.jpg?w=1200&format=avif&as=srcset'
import deCreditStep2Webp from '@/assets/images/credits-page/de-credits-step-2.jpg?w=1200&format=webp&as=srcset'
import deCreditStep3 from '@/assets/images/credits-page/de-credits-step-3.jpg?w=778'
import deCreditStep3Avif from '@/assets/images/credits-page/de-credits-step-3.jpg?w=778&format=avif&as=srcset'
import deCreditStep3Webp from '@/assets/images/credits-page/de-credits-step-3.jpg?w=778&format=webp&as=srcset'
import deCreditStep4 from '@/assets/images/credits-page/de-credits-step-4.jpg?w=1200'
import deCreditStep4Avif from '@/assets/images/credits-page/de-credits-step-4.jpg?w=1200&format=avif&as=srcset'
import deCreditStep4Webp from '@/assets/images/credits-page/de-credits-step-4.jpg?w=1200&format=webp&as=srcset'
import deMobileCreditStep11 from '@/assets/images/credits-page/de-mobile-credits-step-1-1.jpg?w=584'
import deMobileCreditStep11Avif from '@/assets/images/credits-page/de-mobile-credits-step-1-1.jpg?w=584&format=avif&as=srcset'
import deMobileCreditStep11Webp from '@/assets/images/credits-page/de-mobile-credits-step-1-1.jpg?w=584&format=webp&as=srcset'
import deMobileCreditStep12 from '@/assets/images/credits-page/de-mobile-credits-step-1-2.jpg?w=584'
import deMobileCreditStep12Avif from '@/assets/images/credits-page/de-mobile-credits-step-1-2.jpg?w=584&format=avif&as=srcset'
import deMobileCreditStep12Webp from '@/assets/images/credits-page/de-mobile-credits-step-1-2.jpg?w=584&format=webp&as=srcset'
import deMobileCreditStep21 from '@/assets/images/credits-page/de-mobile-credits-step-2-1.jpg?w=584'
import deMobileCreditStep21Avif from '@/assets/images/credits-page/de-mobile-credits-step-2-1.jpg?w=584&format=avif&as=srcset'
import deMobileCreditStep21Webp from '@/assets/images/credits-page/de-mobile-credits-step-2-1.jpg?w=584&format=webp&as=srcset'
import deMobileCreditStep22 from '@/assets/images/credits-page/de-mobile-credits-step-2-2.jpg?w=584'
import deMobileCreditStep22Avif from '@/assets/images/credits-page/de-mobile-credits-step-2-2.jpg?w=584&format=avif&as=srcset'
import deMobileCreditStep22Webp from '@/assets/images/credits-page/de-mobile-credits-step-2-2.jpg?w=584&format=webp&as=srcset'
import deMobileCreditStep3 from '@/assets/images/credits-page/de-mobile-credits-step-3.jpg?w=584'
import deMobileCreditStep3Avif from '@/assets/images/credits-page/de-mobile-credits-step-3.jpg?w=584&format=avif&as=srcset'
import deMobileCreditStep3Webp from '@/assets/images/credits-page/de-mobile-credits-step-3.jpg?w=584&format=webp&as=srcset'
import deMobileCreditStep4 from '@/assets/images/credits-page/de-mobile-credits-step-4.jpg?w=584'
import deMobileCreditStep4Avif from '@/assets/images/credits-page/de-mobile-credits-step-4.jpg?w=584&format=avif&as=srcset'
import deMobileCreditStep4Webp from '@/assets/images/credits-page/de-mobile-credits-step-4.jpg?w=584&format=webp&as=srcset'

import frCreditStep1 from '@/assets/images/credits-page/fr-credits-step-1.jpg?w=1200'
import frCreditStep1Avif from '@/assets/images/credits-page/fr-credits-step-1.jpg?w=1200&format=avif&as=srcset'
import frCreditStep1Webp from '@/assets/images/credits-page/fr-credits-step-1.jpg?w=1200&format=webp&as=srcset'
import frCreditStep2 from '@/assets/images/credits-page/fr-credits-step-2.jpg?w=1200'
import frCreditStep2Avif from '@/assets/images/credits-page/fr-credits-step-2.jpg?w=1200&format=avif&as=srcset'
import frCreditStep2Webp from '@/assets/images/credits-page/fr-credits-step-2.jpg?w=1200&format=webp&as=srcset'
import frCreditStep3 from '@/assets/images/credits-page/fr-credits-step-3.jpg?w=778'
import frCreditStep3Avif from '@/assets/images/credits-page/fr-credits-step-3.jpg?w=778&format=avif&as=srcset'
import frCreditStep3Webp from '@/assets/images/credits-page/fr-credits-step-3.jpg?w=778&format=webp&as=srcset'
import frCreditStep4 from '@/assets/images/credits-page/fr-credits-step-4.jpg?w=1200'
import frCreditStep4Avif from '@/assets/images/credits-page/fr-credits-step-4.jpg?w=1200&format=avif&as=srcset'
import frCreditStep4Webp from '@/assets/images/credits-page/fr-credits-step-4.jpg?w=1200&format=webp&as=srcset'
import frMobileCreditStep11 from '@/assets/images/credits-page/fr-mobile-credits-step-1-1.jpg?w=584'
import frMobileCreditStep11Avif from '@/assets/images/credits-page/fr-mobile-credits-step-1-1.jpg?w=584&format=avif&as=srcset'
import frMobileCreditStep11Webp from '@/assets/images/credits-page/fr-mobile-credits-step-1-1.jpg?w=584&format=webp&as=srcset'
import frMobileCreditStep12 from '@/assets/images/credits-page/fr-mobile-credits-step-1-2.jpg?w=584'
import frMobileCreditStep12Avif from '@/assets/images/credits-page/fr-mobile-credits-step-1-2.jpg?w=584&format=avif&as=srcset'
import frMobileCreditStep12Webp from '@/assets/images/credits-page/fr-mobile-credits-step-1-2.jpg?w=584&format=webp&as=srcset'
import frMobileCreditStep21 from '@/assets/images/credits-page/fr-mobile-credits-step-2-1.jpg?w=584'
import frMobileCreditStep21Avif from '@/assets/images/credits-page/fr-mobile-credits-step-2-1.jpg?w=584&format=avif&as=srcset'
import frMobileCreditStep21Webp from '@/assets/images/credits-page/fr-mobile-credits-step-2-1.jpg?w=584&format=webp&as=srcset'
import frMobileCreditStep22 from '@/assets/images/credits-page/fr-mobile-credits-step-2-2.jpg?w=584'
import frMobileCreditStep22Avif from '@/assets/images/credits-page/fr-mobile-credits-step-2-2.jpg?w=584&format=avif&as=srcset'
import frMobileCreditStep22Webp from '@/assets/images/credits-page/fr-mobile-credits-step-2-2.jpg?w=584&format=webp&as=srcset'
import frMobileCreditStep3 from '@/assets/images/credits-page/fr-mobile-credits-step-3.jpg?w=584'
import frMobileCreditStep3Avif from '@/assets/images/credits-page/fr-mobile-credits-step-3.jpg?w=584&format=avif&as=srcset'
import frMobileCreditStep3Webp from '@/assets/images/credits-page/fr-mobile-credits-step-3.jpg?w=584&format=webp&as=srcset'
import frMobileCreditStep4 from '@/assets/images/credits-page/fr-mobile-credits-step-4.jpg?w=584'
import frMobileCreditStep4Avif from '@/assets/images/credits-page/fr-mobile-credits-step-4.jpg?w=584&format=avif&as=srcset'
import frMobileCreditStep4Webp from '@/assets/images/credits-page/fr-mobile-credits-step-4.jpg?w=584&format=webp&as=srcset'

export const creditStepsImages = [
  {
    name: 'cs-credits-step-1.jpg',
    avif: csCreditStep1Avif,
    webp: csCreditStep1Webp,
    fallback: csCreditStep1,
  },
  {
    name: 'cs-credits-step-2.jpg',
    avif: csCreditStep2Avif,
    webp: csCreditStep2Webp,
    fallback: csCreditStep2,
  },
  {
    name: 'cs-credits-step-3.jpg',
    avif: csCreditStep3Avif,
    webp: csCreditStep3Webp,
    fallback: csCreditStep3,
  },
  {
    name: 'cs-credits-step-4.jpg',
    avif: csCreditStep4Avif,
    webp: csCreditStep4Webp,
    fallback: csCreditStep4,
  },
  {
    name: 'cs-mobile-credits-step-1-1.jpg',
    avif: csMobileCreditStep11Avif,
    webp: csMobileCreditStep11Webp,
    fallback: csMobileCreditStep11,
  },
  {
    name: 'cs-mobile-credits-step-1-2.jpg',
    avif: csMobileCreditStep12Avif,
    webp: csMobileCreditStep12Webp,
    fallback: csMobileCreditStep12,
  },
  {
    name: 'cs-mobile-credits-step-2-1.jpg',
    avif: csMobileCreditStep21Avif,
    webp: csMobileCreditStep21Webp,
    fallback: csMobileCreditStep21,
  },
  {
    name: 'cs-mobile-credits-step-2-2.jpg',
    avif: csMobileCreditStep22Avif,
    webp: csMobileCreditStep22Webp,
    fallback: csMobileCreditStep22,
  },
  {
    name: 'cs-mobile-credits-step-3.jpg',
    avif: csMobileCreditStep3Avif,
    webp: csMobileCreditStep3Webp,
    fallback: csMobileCreditStep3,
  },
  {
    name: 'cs-mobile-credits-step-4.jpg',
    avif: csMobileCreditStep4Avif,
    webp: csMobileCreditStep4Webp,
    fallback: csMobileCreditStep4,
  },

  {
    name: 'sk-credits-step-1.jpg',
    avif: skCreditStep1Avif,
    webp: skCreditStep1Webp,
    fallback: skCreditStep1,
  },
  {
    name: 'sk-credits-step-2.jpg',
    avif: skCreditStep2Avif,
    webp: skCreditStep2Webp,
    fallback: skCreditStep2,
  },
  {
    name: 'sk-credits-step-3.jpg',
    avif: skCreditStep3Avif,
    webp: skCreditStep3Webp,
    fallback: skCreditStep3,
  },
  {
    name: 'sk-credits-step-4.jpg',
    avif: skCreditStep4Avif,
    webp: skCreditStep4Webp,
    fallback: skCreditStep4,
  },
  {
    name: 'sk-mobile-credits-step-1-1.jpg',
    avif: skMobileCreditStep11Avif,
    webp: skMobileCreditStep11Webp,
    fallback: skMobileCreditStep11,
  },
  {
    name: 'sk-mobile-credits-step-1-2.jpg',
    avif: skMobileCreditStep12Avif,
    webp: skMobileCreditStep12Webp,
    fallback: skMobileCreditStep12,
  },
  {
    name: 'sk-mobile-credits-step-2-1.jpg',
    avif: skMobileCreditStep21Avif,
    webp: skMobileCreditStep21Webp,
    fallback: skMobileCreditStep21,
  },
  {
    name: 'sk-mobile-credits-step-2-2.jpg',
    avif: skMobileCreditStep22Avif,
    webp: skMobileCreditStep22Webp,
    fallback: skMobileCreditStep22,
  },
  {
    name: 'sk-mobile-credits-step-3.jpg',
    avif: skMobileCreditStep3Avif,
    webp: skMobileCreditStep3Webp,
    fallback: skMobileCreditStep3,
  },
  {
    name: 'sk-mobile-credits-step-4.jpg',
    avif: skMobileCreditStep4Avif,
    webp: skMobileCreditStep4Webp,
    fallback: skMobileCreditStep4,
  },
  {
    name: 'pl-credits-step-1.jpg',
    avif: plCreditStep1Avif,
    webp: plCreditStep1Webp,
    fallback: plCreditStep1,
  },
  {
    name: 'pl-credits-step-2.jpg',
    avif: plCreditStep2Avif,
    webp: plCreditStep2Webp,
    fallback: plCreditStep2,
  },
  {
    name: 'pl-credits-step-3.jpg',
    avif: plCreditStep3Avif,
    webp: plCreditStep3Webp,
    fallback: plCreditStep3,
  },
  {
    name: 'pl-credits-step-4.jpg',
    avif: plCreditStep4Avif,
    webp: plCreditStep4Webp,
    fallback: plCreditStep4,
  },
  {
    name: 'pl-mobile-credits-step-1-1.jpg',
    avif: plMobileCreditStep11Avif,
    webp: plMobileCreditStep11Webp,
    fallback: plMobileCreditStep11,
  },
  {
    name: 'pl-mobile-credits-step-1-2.jpg',
    avif: plMobileCreditStep12Avif,
    webp: plMobileCreditStep12Webp,
    fallback: plMobileCreditStep12,
  },
  {
    name: 'pl-mobile-credits-step-2-1.jpg',
    avif: plMobileCreditStep21Avif,
    webp: plMobileCreditStep21Webp,
    fallback: plMobileCreditStep21,
  },
  {
    name: 'pl-mobile-credits-step-2-2.jpg',
    avif: plMobileCreditStep22Avif,
    webp: plMobileCreditStep22Webp,
    fallback: plMobileCreditStep22,
  },
  {
    name: 'pl-mobile-credits-step-3.jpg',
    avif: plMobileCreditStep3Avif,
    webp: plMobileCreditStep3Webp,
    fallback: plMobileCreditStep3,
  },
  {
    name: 'pl-mobile-credits-step-4.jpg',
    avif: plMobileCreditStep4Avif,
    webp: plMobileCreditStep4Webp,
    fallback: plMobileCreditStep4,
  },
  {
    name: 'hu-credits-step-1.jpg',
    avif: huCreditStep1Avif,
    webp: huCreditStep1Webp,
    fallback: huCreditStep1,
  },
  {
    name: 'hu-credits-step-2.jpg',
    avif: huCreditStep2Avif,
    webp: huCreditStep2Webp,
    fallback: huCreditStep2,
  },
  {
    name: 'hu-credits-step-3.jpg',
    avif: huCreditStep3Avif,
    webp: huCreditStep3Webp,
    fallback: huCreditStep3,
  },
  {
    name: 'hu-credits-step-4.jpg',
    avif: huCreditStep4Avif,
    webp: huCreditStep4Webp,
    fallback: huCreditStep4,
  },
  {
    name: 'hu-mobile-credits-step-1-1.jpg',
    avif: huMobileCreditStep11Avif,
    webp: huMobileCreditStep11Webp,
    fallback: huMobileCreditStep11,
  },
  {
    name: 'hu-mobile-credits-step-1-2.jpg',
    avif: huMobileCreditStep12Avif,
    webp: huMobileCreditStep12Webp,
    fallback: huMobileCreditStep12,
  },
  {
    name: 'hu-mobile-credits-step-2-1.jpg',
    avif: huMobileCreditStep21Avif,
    webp: huMobileCreditStep21Webp,
    fallback: huMobileCreditStep21,
  },
  {
    name: 'hu-mobile-credits-step-2-2.jpg',
    avif: huMobileCreditStep22Avif,
    webp: huMobileCreditStep22Webp,
    fallback: huMobileCreditStep22,
  },
  {
    name: 'hu-mobile-credits-step-3.jpg',
    avif: huMobileCreditStep3Avif,
    webp: huMobileCreditStep3Webp,
    fallback: huMobileCreditStep3,
  },
  {
    name: 'hu-mobile-credits-step-4.jpg',
    avif: huMobileCreditStep4Avif,
    webp: huMobileCreditStep4Webp,
    fallback: huMobileCreditStep4,
  },
  {
    name: 'ro-credits-step-1.jpg',
    avif: roCreditStep1Avif,
    webp: roCreditStep1Webp,
    fallback: roCreditStep1,
  },
  {
    name: 'ro-credits-step-2.jpg',
    avif: roCreditStep2Avif,
    webp: roCreditStep2Webp,
    fallback: roCreditStep2,
  },
  {
    name: 'ro-credits-step-3.jpg',
    avif: roCreditStep3Avif,
    webp: roCreditStep3Webp,
    fallback: roCreditStep3,
  },
  {
    name: 'ro-credits-step-4.jpg',
    avif: roCreditStep4Avif,
    webp: roCreditStep4Webp,
    fallback: roCreditStep4,
  },
  {
    name: 'ro-mobile-credits-step-1-1.jpg',
    avif: roMobileCreditStep11Avif,
    webp: roMobileCreditStep11Webp,
    fallback: roMobileCreditStep11,
  },
  {
    name: 'ro-mobile-credits-step-1-2.jpg',
    avif: roMobileCreditStep12Avif,
    webp: roMobileCreditStep12Webp,
    fallback: roMobileCreditStep12,
  },
  {
    name: 'ro-mobile-credits-step-2-1.jpg',
    avif: roMobileCreditStep21Avif,
    webp: roMobileCreditStep21Webp,
    fallback: roMobileCreditStep21,
  },
  {
    name: 'ro-mobile-credits-step-2-2.jpg',
    avif: roMobileCreditStep22Avif,
    webp: roMobileCreditStep22Webp,
    fallback: roMobileCreditStep22,
  },
  {
    name: 'ro-mobile-credits-step-3.jpg',
    avif: roMobileCreditStep3Avif,
    webp: roMobileCreditStep3Webp,
    fallback: roMobileCreditStep3,
  },
  {
    name: 'ro-mobile-credits-step-4.jpg',
    avif: roMobileCreditStep4Avif,
    webp: roMobileCreditStep4Webp,
    fallback: roMobileCreditStep4,
  },
  {
    name: 'de-credits-step-1.jpg',
    avif: deCreditStep1Avif,
    webp: deCreditStep1Webp,
    fallback: deCreditStep1,
  },
  {
    name: 'de-credits-step-2.jpg',
    avif: deCreditStep2Avif,
    webp: deCreditStep2Webp,
    fallback: deCreditStep2,
  },
  {
    name: 'de-credits-step-3.jpg',
    avif: deCreditStep3Avif,
    webp: deCreditStep3Webp,
    fallback: deCreditStep3,
  },
  {
    name: 'de-credits-step-4.jpg',
    avif: deCreditStep4Avif,
    webp: deCreditStep4Webp,
    fallback: deCreditStep4,
  },
  {
    name: 'de-mobile-credits-step-1-1.jpg',
    avif: deMobileCreditStep11Avif,
    webp: deMobileCreditStep11Webp,
    fallback: deMobileCreditStep11,
  },
  {
    name: 'de-mobile-credits-step-1-2.jpg',
    avif: deMobileCreditStep12Avif,
    webp: deMobileCreditStep12Webp,
    fallback: deMobileCreditStep12,
  },
  {
    name: 'de-mobile-credits-step-2-1.jpg',
    avif: deMobileCreditStep21Avif,
    webp: deMobileCreditStep21Webp,
    fallback: deMobileCreditStep21,
  },
  {
    name: 'de-mobile-credits-step-2-2.jpg',
    avif: deMobileCreditStep22Avif,
    webp: deMobileCreditStep22Webp,
    fallback: deMobileCreditStep22,
  },
  {
    name: 'de-mobile-credits-step-3.jpg',
    avif: deMobileCreditStep3Avif,
    webp: deMobileCreditStep3Webp,
    fallback: deMobileCreditStep3,
  },
  {
    name: 'de-mobile-credits-step-4.jpg',
    avif: deMobileCreditStep4Avif,
    webp: deMobileCreditStep4Webp,
    fallback: deMobileCreditStep4,
  },
  {
    name: 'fr-credits-step-1.jpg',
    avif: frCreditStep1Avif,
    webp: frCreditStep1Webp,
    fallback: frCreditStep1,
  },
  {
    name: 'fr-credits-step-2.jpg',
    avif: frCreditStep2Avif,
    webp: frCreditStep2Webp,
    fallback: frCreditStep2,
  },
  {
    name: 'fr-credits-step-3.jpg',
    avif: frCreditStep3Avif,
    webp: frCreditStep3Webp,
    fallback: frCreditStep3,
  },
  {
    name: 'fr-credits-step-4.jpg',
    avif: frCreditStep4Avif,
    webp: frCreditStep4Webp,
    fallback: frCreditStep4,
  },
  {
    name: 'fr-mobile-credits-step-1-1.jpg',
    avif: frMobileCreditStep11Avif,
    webp: frMobileCreditStep11Webp,
    fallback: frMobileCreditStep11,
  },
  {
    name: 'fr-mobile-credits-step-1-2.jpg',
    avif: frMobileCreditStep12Avif,
    webp: frMobileCreditStep12Webp,
    fallback: frMobileCreditStep12,
  },
  {
    name: 'fr-mobile-credits-step-2-1.jpg',
    avif: frMobileCreditStep21Avif,
    webp: frMobileCreditStep21Webp,
    fallback: frMobileCreditStep21,
  },
  {
    name: 'fr-mobile-credits-step-2-2.jpg',
    avif: frMobileCreditStep22Avif,
    webp: frMobileCreditStep22Webp,
    fallback: frMobileCreditStep22,
  },
  {
    name: 'fr-mobile-credits-step-3.jpg',
    avif: frMobileCreditStep3Avif,
    webp: frMobileCreditStep3Webp,
    fallback: frMobileCreditStep3,
  },
  {
    name: 'fr-mobile-credits-step-4.jpg',
    avif: frMobileCreditStep4Avif,
    webp: frMobileCreditStep4Webp,
    fallback: frMobileCreditStep4,
  },
]
